const styles = () => ({
  name: {
    fontWeight: 500,
  },
  titleRow: {
    gap: 4,
  },
  resourceKey: {
    display: 'block',
    lineHeight: 1.3,
  },
  description: {
    display: 'block',
    lineHeight: 1.3,
  },
  manualLink: {
    display: 'block',
    marginTop: 2,
    fontStyle: 'italic',
  },
});

export default styles;
